import React from "react";
import Select from "react-select";
import styled from "styled-components";

const SelectContainer = styled(Select)`
  width: 90%;
`;

export default function SelectUI({ options, value, onChange, placeholder }) {
  return (
    <SelectContainer
      setSize={true}
      value={value}
      options={options}
      onChange={(e) => {
        onChange(e.value);
      }}
      placeholder={placeholder}
    />
  );
}
